import { Box, InputBase, styled } from "@mui/material";
import "../../theme/muiTypes.d.ts";

export const SearchContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border?.medium || "#B9CED5"}`,
  backgroundColor: theme.palette.background.secondary,
  height: "48px",
  padding: "0 16px",
  display: "flex",
  gap: "10px",
  alignItems: "center",
  "&:hover": {
    borderColor: theme.palette.primary?.main || "#3A8AB9",
  },
  "&:focus-within": {
    borderColor: theme.palette.primary?.main || "#3A8AB9",
    outline: "none",
  },
}));

export const SearchInput = styled(InputBase)(({ theme }) => ({
  width: "100%",
  height: "100%",
  "& .MuiInputBase-input": {
    padding: 0,
    fontSize: "16px",
    color: theme.palette.text?.primary || "#1B252F",
    "&::placeholder": {
      color: theme.palette.text?.secondary,
      opacity: 1,
    },
  },
}));
